export class TipoSezione {
    id: string;
    descrizione: string;
    label: string;
    rimosso: boolean;
}
